import api from '@/api'
import axios from 'axios'
import { mapGetters } from 'vuex'
import ReplyCommentBox from './ReplyCommentBox'
import ReplyCommentSearchBox from './ReplyCommentSearchBox'
import ReplyCommentSearchPost from './ReplyCommentSearchPost'
import ReplyCommentTab from './ReplyCommentTab'
import ReplyCommentTool from './ReplyCommentTool'
import ReplyCommentUsers from './ReplyCommentUsers'

export default {
  components: {
    ReplyCommentBox,
    ReplyCommentUsers,
    ReplyCommentSearchBox,
    ReplyCommentSearchPost,
    ReplyCommentTab,
    ReplyCommentTool
  },
  data() {
    return {
      app: '',
      timer: '',
      loadingUser: true,
      isBotreply: false,
      isMobile: false,
      selectedPostId: null,
      limit: 100,
      offset: 0,
      commentList: [],
      selectedComment: null,
      chatlog: null,
      postid: null,
      pageid: null,
      facebookPostList: null
    }
  },
  async mounted() {
    var vm = this
    await vm.getFacebookPost()
    await vm.$store.dispatch('loadAgents')
    await vm.$store.dispatch('loadAgentGroups')
    await vm.$store.dispatch('loadAgentSubGroups')
    if (vm.$route.query.postid) {
      vm.$store.state.rabbitSelectedPostId = vm.$route.query.postid
      vm.postid = vm.$route.query.postid
    }
    await vm.getUserThreadWithPost()

    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        await vm.getUsersdata(userid).then(function (user) {
          if (user) {
            vm.selectedComment = {
              first_name: user.first_name,
              last_name: user.last_name,
              lastreply_time: null,
              profile_pic: user.profile_pic,
              session: '',
              sessionvalue: user.sessionvalue,
              userid: user.id,
              uu_areaname: null,
              type: user.context == 'contactadmin' ? 'admin' : ''
            }
            vm.onSelectedUser(vm.selectedComment)
          } else {
            vm.$swal({
              type: 'info',
              title: 'Not found this user'
            })
          }
        })
      }
    }

    vm.onResize()
    vm.pageid = this.selectedBot.pageid
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async getFacebookPost() {
      var vm = this
      var token = vm.selectedBot.page_access_token
      var pageid = vm.selectedBot.pageid
      var url = `https://graph.facebook.com/v4.0/${pageid}/posts?access_token=${token}`

      await axios.get(url).then(async (response) => {
        if (response.status == 200) {
          vm.facebookPostList = await response.data.data
          if (vm.facebookPostList) {
            vm.postCount = vm.facebookPostList.length
            vm.$store.state.rabbitSelectedPostId = vm.facebookPostList[0].id
            vm.postid = await vm.$store.state.rabbitSelectedPostId
          }
        }
      })
    },
    onResize() {
      this.isMobile = window.innerWidth < 960
    },
    onSelectedPost(id) {
      if (id) {
        this.postid = id
        this.getUserThreadWithPost()
      }
    },
    async getUserThreadWithPost(filter = null) {
      var vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset,
        postid: vm.postid,
        botreply: vm.isBotreply
      }

      if (filter) {
        if (filter.phoneno) {
          Object.assign(data, { phoneno: filter.phoneno })
        }
        if (filter.search) {
          Object.assign(data, { search: filter.search })
        }
        if (filter.tags) {
          Object.assign(data, { search: filter.tags })
        }
        if (filter.ticketStatus) {
          Object.assign(data, { ticketStatus: filter.ticketStatus })
        }
      }
      vm.loadingUser = true
      await api.getRabbitUserThreadWithPost(data, async function (error, response) {
        if (error) reject(error)

        if (response && response.responsecode == 200) {
          vm.commentList = await response.data
          vm.loadingUser = false
        }
      })
    },
    async getChatlogWithPost(userid) {
      var vm = this

      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset,
        postid: vm.postid,
        userid: userid
      }

      await api.getRabbitChatlogWithPost(data, function (error, response) {
        if (error) reject(error)

        if (response && response.responsecode == 200) {
          vm.chatlog = response.data
        }
      })
    },
    onSelectedUser(user) {
      var vm = this
      let userid = user.userid
      vm.selectedComment = user

      if (user && user.commentid) {
        api.postRabbitAdminReadChat(
          {
            postid: vm.postid,
            commentid: user.commentid,
            userid: user.userid
          },
          () => {
            vm.$nextTick(() => {
              user.adminread = true
              vm.$forceUpdate()
            })
          }
        )
      }

      vm.getChatlogWithPost(userid)
    },
    onSetCommentType(val) {
      this.selectedComment = null
      this.isBotreply = val

      if (this.postid) {
        this.getUserThreadWithPost()
      }
    },
    getUsersdata: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.selectedBot.pageid
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    OnSearch(payload) {
      this.getUserThreadWithPost(payload)
    },
    onClearSearch() {
      this.getUserThreadWithPost()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentFBPost.js